const BASE_URL =
  'https://pay.hotmart.com/M104629766Y?hideBillet=1&offDiscount=80OFF'

export function useCheckoutUrl() {
  const params = new URLSearchParams(window.location.search)
  const src = params.get('src')
  const checkoutUrl = src
    ? `${BASE_URL}&src=${encodeURIComponent(src)}`
    : BASE_URL

  const handleCheckout = () => {
    // Fire Facebook AddToCart event before redirecting
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Sueño Profundo Hormonal',
        content_type: 'product',
        value: 110,
        currency: 'MXN',
      })
    }
    window.open(checkoutUrl, '_blank')
  }

  return { checkoutUrl, handleCheckout }
}
